import { lazy, Fragment, Suspense, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'dibs-react-intl';
import classnames from 'classnames';
import { Spinner } from 'dibs-elements/exports/Spinner';
import styles from './PdpRespHeroCarouselVimeo.scss';

const PdpRespHeroCarouselVimeoLazy = lazy(() =>
    import(
        /* webpackChunkName: "PdpRespHeroCarouselVimeo" */
        './PdpRespHeroCarouselVimeo'
    )
);

export const PdpRespHeroCarouselVimeoLazyLoader = props => {
    const [isLoading, setIsLoading] = useState(true);
    const [lazyLoad, setLazyLoad] = useState(props.isCurrentItem);
    if (props.isCurrentItem && !lazyLoad) {
        setLazyLoad(true);
    }
    return (
        <Fragment>
            <div
                className={classnames(styles.loadingContainer, {
                    [styles.loading]: isLoading,
                })}
            >
                <Spinner dark size="small" />
                <span className={styles.loadingText}>
                    <FormattedMessage
                        id="PdpRespHeroCarouselVimeoLoading.loadingVideo"
                        defaultMessage="Video Loading"
                    />
                </span>
            </div>
            {lazyLoad && (
                <Suspense fallback="">
                    <PdpRespHeroCarouselVimeoLazy {...props} onLoad={() => setIsLoading(false)} />
                </Suspense>
            )}
        </Fragment>
    );
};
PdpRespHeroCarouselVimeoLazyLoader.propTypes = {
    isCurrentItem: PropTypes.bool,
};
